// extracted by mini-css-extract-plugin
export default {"root":"collapsible_root__O5h81","content":"collapsible_content__avtqU","slideRight":"collapsible_slideRight__NScHx","slideLeft":"collapsible_slideLeft__ux+78"};